import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Select } from "antd";
import InnerHeading from "../../Global Functions/innerHeading";
import { ReactComponent as DealsIcon } from "../../Global Icons/Deals.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import SelectInput from "../../Global Functions/selectInput";
import TextInput from "../../Global Functions/textInput";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import AddImage from "../../Global Functions/addImage";
import MultipleImagesShowerModalGlobal from "../../Global Functions/multipleImagesShowerModalGlobal";
import { getProjectData } from "../../Redux/Actions/projectActions";
import { addProperty, getSubcategories } from "../../Redux/Actions/propertyActions";
import { viewUnitListNoPagination } from "../../Redux/Actions/unitsActions";
import { ToFirstCapital, ToLowerCase } from "../../Utils/helpers";
import PropertyCategoryHandler from "../../Commercial/Commercial Functions/propertyCategoryHandler";

const AddProperties = () => {
  const { id } = useParams();
  // const [inputMessages, setInputMessages] = useState(''); 
  // const [messages, setMessages] = useState([])
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { enumsData } = useSelector((state) => state.enumsData);

  const { project } = useSelector((state) => state.projects || {});

  // const [propertyData, setPropertyData] = useState({});

  const [projectPayload, setProjectPayload] = useState({
    added_by: "admin",
    project_id: id,
    project_name: project?.data?.project_name,
    project_type: project?.data?.project_type?._id,
    construction_status: project?.data?.construction_status,
    total_quantity: "",
    no_of_kitchen: "",
    no_of_bedroom: "",
    no_of_bathroom: "",
    no_of_balcony: "",
    open_parking: "",
    starting_price: "",
    cover_parking: "",
    unit: "",
    unit_area: "",
    price_per_sq_ft: "",
    category: "",
    about_property: "",
    cover_photos: [],
    images: [],
    additional_rooms: [],
  });

  const [selectedCategory, setSelectedCategory] = useState("");

  useEffect(() => {
    const projectType = project?.data?.project_type?.name?.toLowerCase();
    if (projectType === "residential") {
      setUnitSelection(residentialUnits);
    } else if (projectType === "commercial") {
      setUnitSelection(commercialUnits);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project?.data?.project_type?.name]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (project?.data?.project_name) {
      setProjectPayload((prevData) => ({
        ...prevData,
        project_name: project.data.project_name,
      }));
    }
  }, [dispatch, project?.data]);

  const handlerNavigation = () => {
    navigate("/enquiry");
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setProjectPayload((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleAddImages = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) {
      return toast.error("Please Upload Image");
    }
    const responseUrl = await AddImage(uploadedImage);
    if (responseUrl) {
      const newImage = {
        url: responseUrl,
        index: projectPayload.images.length + 1,
      };
      setProjectPayload((prevData) => ({
        ...prevData,
        images: [...prevData.images, newImage],
      }));
    }
  };

  const getPropertyData = (propData) => {
    setProjectPayload((prevData) => ({ ...prevData, ...propData }));
  };

  const handleSubmit = async (event) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(projectPayload)?.filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );

      const response = await dispatch(addProperty(filteredPayload));
      response.statusCode === 200
        ? navigate("/enquiry")
        : toast.error(response?.message);
    } catch (error) {
      return toast.error(error?.message);
    }
  };

  const handleCoverImage = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) {
      return toast.error("Please Upload Image");
    }
    const responseUrl = await AddImage(uploadedImage);
    const newImage = {
      url: responseUrl,
      index: projectPayload.cover_photos.length + 1,
    };

    if (responseUrl) {
      setProjectPayload((prevData) => ({
        ...prevData,
        cover_photos: [...prevData.cover_photos, newImage],
      }));
    }
  };

  useEffect(() => {
    dispatch(viewUnitListNoPagination({ filter: projectPayload.project_type }));
    dispatch(getProjectData(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  const { units } = useSelector((state) => state.units || {});
    const { subcategories } = useSelector((state) => state.properties || {});
  const unitsList = units?.data || [];

  const commercialUnits = unitsList.filter(
    (unit) => unit?.project_type?.name?.toLowerCase() === "commercial"
  );

  const residentialUnits = unitsList.filter(
    (unit) => unit?.project_type?.name?.toLowerCase() === "residential"
  );

  const [ setUnitSelection] = useState(residentialUnits);
  const [selectedSubcategory,setSelectedSUbcategory]= useState("")

  const categorySelectionHandler = (event) => {
    const selectedCatId = event.target.value;
    dispatch(getSubcategories(
      { "category_id": selectedCatId }));
    setProjectPayload((prevData) => ({
      ...prevData,
      category: selectedCatId,
    }));
    const foundCategory = project?.data?.categories?.find(
      (cat) => cat._id === selectedCatId
    );
    console.log("Selected Category",foundCategory)
    setSelectedCategory(foundCategory);
  };
  const subcategorySelectionHandler=(event)=>{
    const selectedSubcatId= event.target.value;
    setProjectPayload((prevData)=>({
      ...prevData,
      subcategory:selectedSubcatId

    }))
    setSelectedSUbcategory(selectedSubcatId)
    
  }

  const handleChange=(e)=>{
  setProjectPayload({...projectPayload,additional_rooms:e})

  }
  useEffect(()=>{
console.log("hh",projectPayload)
  },[projectPayload])
  return (
    <MainLayout>
      <div className="bg-white grid-span-5 radius-20 padding-20 grid-template-2 gap-10 row-span-8">
        <InnerHeading
          Icon={DealsIcon}
          onClick={() => handlerNavigation()}
          heading="Add Properties"
          buttonLabel="View Projects"
        ></InnerHeading>
        <TextInput
          label="Project Name"
          disabled
          type="text"
          value={project?.data ? project.data.project_name : ""}
        ></TextInput>
        <TextInput
          label="Project Type"
          disabled
          value={
            project?.data?.project_type ? project.data.project_type.name : ""
          }
        ></TextInput>
        <TextInput
          label="RERA-ID"
          disabled
          value={project?.data ? project.data.rera_id : ""}
        ></TextInput>
        <SelectInput
          label="Category"
          placeholder="Select an Option"
          value={projectPayload.category}
          name="category"
          onChange={categorySelectionHandler}
          options={
            Array.isArray(project?.data?.categories)
              ? project.data.categories.map((item) => ({
                  label: ToFirstCapital(item.name),
                  value: item._id,
                }))
              : []
          }
        ></SelectInput>

        <SelectInput
          disabled={projectPayload.category?false:true}
          label="SubCategory"
          placeholder="Select an Option"
          value={selectedSubcategory}
          name="SubCategory"
          onChange={subcategorySelectionHandler}
          options={
            Array.isArray(subcategories?.data)
              ? subcategories.data.map((item) => ({
                label: ToFirstCapital(item.name),
                value: item._id,
              }))
              : 
              []
          }
        ></SelectInput>
        <SelectInput
          placeholder="Select an Option"
          required
          value={projectPayload.unit}
          options={
            units?.data
              ? units.data.map((item) => ({
                  label: item.name,
                  value: item._id,
                }))
              : []
          }
          name="unit"
          onChange={handleAddChange}
          label="Select Furnishing Unit"
        ></SelectInput>
        <TextInput
          name="unit_area"
          min={0}
          value={projectPayload.unit_area}
          label="Area of Property(sq.ft)"
          type="number"
          onChange={handleAddChange}
        ></TextInput>
        <TextInput
          name="price_per_sq_ft"
          min={0}
          label="Price/ sq.ft"
          type="number"
          onChange={handleAddChange}
        ></TextInput>
        <div className="custom_room_select">


  <Select
      mode="multiple"
      allowClear
      style={{ width: '100%' }}
      placeholder="Please select"
      onChange={handleChange}
      options={enumsData?.data?.additional_rooms?.map((val)=> ({
                            label: val.value,
                            value: val.value
                          }))
                        }
    />
     </div>
        <div className="grid-span-2 border-1-grey padding-10 border-10">
          {selectedCategory.name ? (
            <h3 className="margin-h-10">
              Specific Details - {ToFirstCapital(selectedCategory?.name)}
            </h3>
          ) : (
            <h3>Specific Details</h3>
          )}
          {ToLowerCase(selectedCategory.name) === "apartment" ? (
            <div className="grid-span-2">
              <div className="grid-template-2 gap-10">
                <TextInput
                  name="no_of_kitchen"
                  min={0}
                  required
                  label="No. Of Kitchen"
                  type="number"
                  disabled={
                    project?.data?.categories?.map(
                      (item) => item.name === "apartment"
                    )
                      ? false
                      : true
                  }
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  name="no_of_bathroom"
                  required
                  min={0}
                  label="No. Of Bathroom"
                  type="number"
                  disabled={
                    project?.data?.categories?.map(
                      (item) => item.name === "apartment"
                    )
                      ? false
                      : true
                  }
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  name="no_of_balcony"
                  min={0}
                  required
                  label="No. Of Balcony"
                  disabled={
                    project?.data?.categories?.map(
                      (item) => item.name === "apartment"
                    )
                      ? false
                      : true
                  }
                  type="number"
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  name="no_of_bedroom"
                  min={0}
                  required
                  label="No. Of Bedroom"
                  disabled={
                    project?.data?.categories?.map(
                      (item) => item.name === "apartment"
                    )
                      ? false
                      : true
                  }
                  type="number"
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  min={0}
                  name="open_parking"
                  label="Open Parking"
                  type="number"
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  min={0}
                  name="cover_parking"
                  label="Cover Parking"
                  type="number"
                  onChange={handleAddChange}
                ></TextInput>
                <TextInput
                  min={0}
                  name="pantry"
                  label="pantry"
                  type="number"
                  onChange={handleAddChange}
                ></TextInput>
              </div>
            </div>
          ) : null}
          <PropertyCategoryHandler
            category={selectedCategory.name}
            onChange={getPropertyData}
          ></PropertyCategoryHandler>
        </div>
        <TextInput
          label="Starting Price"
          type="number"
          required
          onChange={handleAddChange}
          name="starting_price"
        ></TextInput>
        <div className="grid-span-2">
          <TextInput
            name="about_property"
            label="About Property"
            type="text"
            onChange={handleAddChange}
          ></TextInput>
        </div>
        <div>
          <TextInput
            forImage={true}
            htmlFor="cover_photos"
            span="Cover Image(Max 3)"
            disabled={projectPayload.cover_photos.length === 3 ? true : false}
            required
            max={3}
            onChange={(event) => handleCoverImage(event)}
            type="file"
            label="Click to Upload Image"
            id="cover_photos"
            name="cover_photos"
          ></TextInput>
          <MultipleImagesShowerModalGlobal
            state={projectPayload.cover_photos}
            setState={setProjectPayload}
            fieldName="cover_photos"
          ></MultipleImagesShowerModalGlobal>
        </div>
        <div>
          <TextInput
            forImage={true}
            htmlFor="images"
            onChange={(event) => handleAddImages(event)}
            type="file"
            span="Property Images"
            required
            label="Click to Upload Image"
            id="images"
            name="images"
          ></TextInput>
          <MultipleImagesShowerModalGlobal
            state={projectPayload.images}
            setState={setProjectPayload}
            fieldName="images"
          ></MultipleImagesShowerModalGlobal>
        </div>
        <div className="grid-span-2 flex-end">
          <Link to="/enquiry">
            <button className="button-class-white">Cancel</button>
          </Link>
          <button className="button-class" onClick={() => handleSubmit()}>
            Save
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddProperties;
